module.exports = "https://99designs-start-assets.imgix.net/js/8fdf4e4b1f38dec72f44aac29bd6bef9.png";